@if (summaryList) {
  <dl
    class="govuk-summary-list govuk-!-margin-bottom-0"
    [class.govuk-summary-list--no-border]="topBorder || wrapBorder"
    [class.govuk-summary-list--top-border]="topBorder"
    [class.govuk-summary-list--wrap-border]="wrapBorder"
  >
    @for (item of summaryList; track $index) {
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">
          @if (item.showNewFlag) {
            <!-- <img
              class="asc-red-pill-icon--m-size"
              src="/assets/images/big-red-pill.svg"
              data-testid="new-pill"
              alt="new"
            /> -->
            <img
              class="asc-red-pill-icon--m-size govuk-!-margin-right-2"
              src="/assets/images/new-icon.png"
              data-testid="new-pill"
              alt="new"
            />
          }
          {{ item.label }}
        </dt>
        @if (item.label === 'Password' && displayShowPasswordToggle) {
          <dd class="govuk-summary-list__value">
            <span class="asc-password-wrap">{{ showPassword ? item.data : '******' }}</span>
            <a
              class="govuk-link govuk-link--no-visited-state govuk-!-margin-left-6"
              href="#"
              role="button"
              (click)="togglePassword($event)"
            >
              @if (showPassword) {
                Hide
              } @else {
                Show
              }
              password</a
            >
          </dd>
        } @else {
          <dd class="govuk-summary-list__value asc__preline">
            @if (item.data === null) {
              -
            } @else {
              {{ item.data }}
            }
          </dd>
        }
        @if (item.route) {
          @if (canNavigate === undefined ? true : canNavigate) {
            <dd class="govuk-summary-list__actions">
              <a [routerLink]="item.route.url" (click)="emitSetReturn()">
                @if (!item.data) {
                  Add
                } @else {
                  Change
                }
                <span class="govuk-visually-hidden">
                  {{ item.ariaDescription ? item.ariaDescription : item.label.toLowerCase() }}
                </span>
              </a>
            </dd>
          }
        }
      </div>
    }
  </dl>
}
